var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sync",
    clipPath: "url(#clip0_43_11593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1463 9.55795V8.62649C14.1463 5.54051 11.6383 3.03809 8.5451 3.03809C7.70364 3.03705 6.87279 3.22583 6.11439 3.59036C5.35599 3.9549 4.68958 4.4858 4.16477 5.14355M2.96045 7.70661V8.63806C2.96045 11.7275 5.46724 14.228 8.56167 14.228C9.40073 14.2268 10.2289 14.0384 10.986 13.6766C11.743 13.3147 12.4097 12.7885 12.9376 12.1363",
    stroke: "#585858",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.56006 8.63437L2.93637 7.25806L4.37524 8.63437",
    stroke: "#585858",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.5657 8.63269L14.1894 10.009L12.7505 8.63269",
    stroke: "#585858",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_11593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0035,
    height: 16.0035,
    fill: "white",
    transform: "translate(0.55957 0.630615)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/sync-icon.580682155937f97666d159884140ae24.svg";
export { ForwardRef as ReactComponent };